import { Open, Click, Hover } from '../actions'
import { HeaderLanguage } from '../objects/HeaderLanguage'
import { HeaderSearchIcon } from '../objects/HeaderSearchIcon'

import { Navigation } from '../objects/Navigation'
import { analytics } from './lib'

export function NavigationMenuOpen(label: string) {
  return analytics(
    new Open(),
    new Navigation({ navigationMenuLabel: label, navigationItemLocation: 'header' }),
  )
}

export function NavigationItemClick(
  url: string | null,
  location: 'header' | 'footer',
  type?: string,
) {
  return analytics(
    new Click(),
    new Navigation({
      navigationItemTargetUrl: url,
      navigationItemLocation: location,
      navigationItemType: type,
    }),
  )
}

export function HeaderLanguageMenuOpen() {
  return analytics(new Open(), new HeaderLanguage({}))
}

export function HeaderLanguageItemClick(lang: string) {
  return analytics(new Click(), new HeaderLanguage({ headerLanguageItemTargetLang: lang }))
}

export function HeaderSearchIconClick() {
  return analytics(new Click(), new HeaderSearchIcon())
}

export function HeaderSearchIconHover() {
  return analytics(new Hover(), new HeaderSearchIcon())
}
